import { createApp } from 'vue'
import App from './App.vue'

import router from '@/router/index'
import { createPinia } from 'pinia'
import 'element-plus/dist/index.css'
import './assets/css/over-write.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/css/global.css'
import 'virtual:uno.css'
import './assets/ueditor/ueditor.config';
import './assets/ueditor/ueditor.all.min';
import './assets/ueditor/lang/zh-cn/zh-cn';
import './assets/ueditor/themes/default/css/ueditor.css';
window.design_obj = []
if (process.env.NODE_ENV === 'development') {
  // document.cookie = 'OCSESSID=cbeeb6ed865f014df8d796abb6' // dev
  document.cookie = 'OCSESSID=045fcd5f99525dc3ca38d5be49' // prod
}
const app = createApp(App)
app.use(router).use(createPinia()).mount('#app')

